import React,{ useState, useEffect } from 'react';
import { ThemeProvider, Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import {components, myTheme, FormFields} from './utils/customLoginScreen.js'
import { isMobile } from 'react-device-detect';
import { UnAuthMaps } from './components/UnAuthMap.js';

import { CssBaseline, extendTheme, Card, Typography } from '@mui/joy';
import {ThemeProvider as JoyUIThemeProvider} from '@mui/joy'

import { useLocation, useNavigate, Route, Routes } from 'react-router-dom';
import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';

import Box from '@mui/joy/Box';

import {Navbar} from './components/Navbar.js';
import {BlankMapBody, SpearheadMapBody,WB256600, WB512600, WB1024600, WhistlerBlackcombMapBody} from './components/mapBody.js';
import { UpdateNameModalIMPORTANT, WaiverModalIMPORTANT, SpearheadWarningModal } from './utils/Modals/infoUpdateModals.js';
import Footer from './utils/Footer.js'
import SplashPage from './components/SplashPage.js';
import AdminAccess from './components/pages/AdminAccess.js';
import AboutPage from './components/pages/AboutPage.js';
import DonationsPage from './components/pages/DonationsPage.js';
import PrintPurchasePage from './components/pages/PrintPurchasePage.js';
import ContactPage from './components/pages/ContactPage.js';

import { usePosition } from './utils/MapUtils/MapContext/PositionContext.js';
import UpdateNotification from './utils/Modals/updateNotification.js';

import './App.css';
import { PrivacyPolicy } from './components/PrivacyPolicy.js';

const theme = extendTheme({
  fontFamily: {
    display:'roboto',
    body:'roboto',
  },
});

function App() {

  const [showSplash, setShowSplash] = useState(true)
  const [updateUserName, setUpdateUserName] = useState(false)
  const [signWaiver, setSignWaiver]= useState(false)
  const [spearheadWarning, setSpearheadWarning] = useState(false)
  const [currentMap, setCurrentMap] = useState('WhistlerBlackcomb')
  const { setPosition, currentUserRoles, setCurrentUserRoles, setUserID } = usePosition();

  //offline mode registration
  async function registerSync() {
    const swRegistration = await navigator.serviceWorker.ready;
    swRegistration.sync.register("send-message");
  }

  // control for spearhead modal display

  const handleSpearheadWarningClose=()=> {
    setSpearheadWarning(false)
  }

  useEffect(()=>{
    if (currentMap === 'spearhead') {
      setSpearheadWarning(true)
    }
  }, [currentMap])
  
  //display modal for userName update
  const handleUpdateNameIMPORTANTClose = () =>{
    setUpdateUserName(false)
  }

  const handleSignWaiverClose = () => {
    setSignWaiver(false)
  }

  // sets current map
  const handleSetCurrentMap = (map) => {
    setCurrentMap(map)
    setPosition({ latitude: null, longitude: null, zoom: null })
  }

  const location = useLocation();
  const navigate = useNavigate()

  //=============================below is splashscreen logic========================
  //if location changes to base, will show the splashscreen
  useEffect(() => {
    if (location.pathname === '/') {
      setShowSplash(true);
    }
  }, [location.pathname]);

  //load user data when location path changes
  useEffect(() => {
    if (location.pathname=== '/auth') {
      handleUserLoad()
    }
  }, [location.pathname])

  // below sets the splashpage to end its displya
  const handleSplashEnd = () => {
    //handleUserLoad()
    setShowSplash(false);
    userLoginRedirect()
    //navigate('/maps')

  };


  //checks user login and changes path based on login status
  const userLoginCheck = async() => {
    try {
      await fetchAuthSession()
      console.log('logging in')
      //navigate('/auth')
      return true
    } catch {
      console.log('unauthenticated')
      //navigate('/maps')
      return false
    }
  } 

  const userLoginRedirect = async() => {

    if (location.pathname.endsWith("/privacy-policy")) {
      return;
    }

    const isLoggedIn = await userLoginCheck()
    if (isLoggedIn===true) {
      navigate('/auth')
    } else {
      navigate('/maps')
    }

  }

  // below for determining admin access
  const handleUserLoad = async () => {
    const isLoggedIn = await userLoginCheck()
   if (isLoggedIn===true) {
   
    try {
      const session = await fetchAuthSession();
      //console.log('session')
      //console.log(session.tokens)
      setCurrentUserRoles(session.tokens.idToken.payload["cognito:groups"])
      console.log('Current user array:', session.tokens.idToken.payload["cognito:groups"]);
      //console.log("cognito groups", session.tokens.idToken.payload["cognito:groups"])
      
  } catch(error) {
    console.log('error retrieving user data')
    console.log(error)
  }
  try {
    const userAttributes = await fetchUserAttributes();
    console.log('fetching userAttributes')
    if (!userAttributes.preferred_username) {
      console.log('adjust username')
      setUpdateUserName(true)
    } else {
      setUserID({
        email:userAttributes.email,
        username:userAttributes.preferred_username,
      })
    }
    if (!userAttributes.zoneinfo) { 
      console.log('sign Waiver')
      setSignWaiver(true)
    }
    } catch(error) {
      console.log('error fetching user attributes')
      console.log(error)
    }
    }
  }

  return (
    
    <>
    <JoyUIThemeProvider theme={theme}>
    <CssBaseline /> {/* Apply global styles including the font */}
    {showSplash && <SplashPage onSplashEnd={handleSplashEnd} />}
    {!showSplash && (
      <ThemeProvider theme={myTheme}>
                  {/* Information Card with Text */}
        <UpdateNotification/>
    <Routes>
    <Route path ='/auth' element ={<>
    <Authenticator components={components} className='authenticator-background' formFields={FormFields} >
      <Box className={location.pathname === '/login' ? 'login-background' : ''}>

        <Navbar handleSetCurrentMap={handleSetCurrentMap} currentMap={currentMap} setCurrentMap={setCurrentMap} isSignedIn={true}/>

        <UpdateNameModalIMPORTANT open={updateUserName} handleClose={handleUpdateNameIMPORTANTClose}/>
        <WaiverModalIMPORTANT open={signWaiver} handleClose={handleSignWaiverClose} isSignedIn={true}/>
        <SpearheadWarningModal open={spearheadWarning} handleClose={handleSpearheadWarningClose}/>
        {location.pathname === '/auth'
          &&
        currentMap === 'blankmap' ? <BlankMapBody handleSetCurrentMap={handleSetCurrentMap}/>:
        currentMap === 'spearhead' ? <SpearheadMapBody isSignedIn={true}/>:
        currentMap === 'WhistlerBlackcomb' ? <WhistlerBlackcombMapBody isSignedIn={true}/>:
        /*
        currentMap === 'WBLowRes' ? isMobile? <WB256600 isSignedIn={true}/>:<WB512600 isSignedIn={true}/>:
        currentMap === 'WBHighRes' ? isMobile? <WB512600 isSignedIn={true}/> : <WB1024600 isSignedIn={true}/> :
        */
        currentMap === 'Admin'? <AdminAccess handleSetCurrentMap={handleSetCurrentMap}/> :
        currentMap === 'About' ?<AboutPage handleSetCurrentMap={handleSetCurrentMap}/>:
        currentMap === 'Support ULLR' ?<DonationsPage handleSetCurrentMap={handleSetCurrentMap}/>:
        currentMap === 'Purchase Prints' ?<PrintPurchasePage handleSetCurrentMap={handleSetCurrentMap}/>:
        currentMap === 'Get in Touch' ?<ContactPage handleSetCurrentMap={handleSetCurrentMap}/>:
        <WhistlerBlackcombMapBody isSignedIn={true}/>
      }
        <Footer/>
      </Box>

    </Authenticator>
    </>}/>
        <Route path='/' element={showSplash && <SplashPage onSplashEnd={handleSplashEnd} />}/>
        <Route path ='/maps' element ={<>
        <UnAuthMaps/>
        </>}/>
      <Route path ='/privacy-policy' element ={<>
        <PrivacyPolicy />
        </>}/>


    </Routes>
    </ThemeProvider>
    )}
    </JoyUIThemeProvider>
    </>
  );
}

export default App;
